module.exports = __webpack_public_path__ + "img/graph_dementia.86e0ff62.png";